export default "__VITE_ASSET__BrhZSVir__"